// extracted by mini-css-extract-plugin
module.exports = {"link":"LogoutLink_link__3hGyn"};